import { inject, InjectionToken } from '@angular/core';
import { UserProfileService } from 'api';
import { map, Observable } from 'rxjs';

export interface AuthPermissionsConfig {
  // Define your auth permission settings here
  permissions: Observable<string[]>;
}

export const AUTH_PERMISSIONS_CONFIG =
  new InjectionToken<AuthPermissionsConfig>('auth-permissions-config');

export const provideAuthConfig = (
  configFactory?: () => AuthPermissionsConfig
) => ({
  provide: AUTH_PERMISSIONS_CONFIG,
  useFactory: configFactory
    ? configFactory
    : () => {
        const permissionsService = inject(UserProfileService);
        return {
          permissions: permissionsService
            .getUserPermissions()
            .pipe(map(({ permissions }) => permissions)),
        };
      },
});
